import React from 'react';
import { Select } from 'antd';
import styled from 'styled-components';

const StyledSelect = styled(Select)`
  width: auto;
  min-width: 195px;
`;

const AmountSelect = ({ fields = [], field, onChange }) => (
  <StyledSelect
    onChange={(value) => onChange(fields.find(({ path }) => path === value))}
    value={field.path}
    dropdownMatchSelectWidth
    dropdownStyle={{ width: 'auto' }}
    className="ant-select-border-bottom"
    getPopupContainer={(triggerNode) => triggerNode}
    virtual={false}
  >
    {fields.map((o) => (
      <Select.Option key={o.path} value={o.path}>
        {o.label}
      </Select.Option>
    ))}
  </StyledSelect>
);

export default AmountSelect;
